'use strict';

(function (global) {

  /**
   * @class BaseDocumentPostprocessor
   * @classdesc Подготовка сконвертированного документа к предпросмотру.
   * @hideconstructor
   * @namespace window.Core.preview
   * @since 5.7.0
   */
  class BaseDocumentPostprocessor {

    /**
     * Подготовить загруженный документ к предпросмотру.
     *
     * @method prepare
     * @param {object} jFrame jQuery-объект содержимого iframe предпросмотра.
     * @param {object} filePath Объект с путями к подключаемым файлам
     * @param {string} [filePath.css] Путь к подключаемому css-файлу
     * @param {string} [filePath.js] Путь к подключаемому js-файлу
     * @param {string} extension Оригинальное расширение файла сконвертированного документа
     * @return {Promise<void>}
     * @static
     */
    static prepare(jFrame, filePath, extension) {
      const jFrameContents = jFrame.contents();
      this._isIpad = (WA.ENV.device.model && WA.ENV.device.model.toLowerCase() === 'ipad');
      if (this._isIpad) {
        // Если не установить высоту, то в iOs отпадет скроллинг для фреймов в таблицах
        jFrame.parent().height(jFrame.closest('body').height() - jFrame.offset().top);
      }

      // Прячем раскрытые выпадашки тулбара предпросмотра при клике на содержимое iframe
      jFrameContents.on('click', () => {
        $('body').trigger('click.DropDownList');
      });

      return new Promise(resolve => {
        this._addFilesToHead(jFrameContents, filePath).then(() => {
          this._prepareContents(jFrame, extension);

          resolve();
        });
      });
    }

    /**
     * Добавить файлы стилей и скриптов к iframe предпросмотра.
     *
     * @method _addFilesToHead
     * @param {object} jFrameContents jQuery-объект содержимого iframe предпросмотра.
     * @param {array} filePath
     * @private
     * @return {Promise<void>}
     * @static
     */
    static _addFilesToHead(jFrameContents, filePath) {
      return new Promise(resolve => {
        const jFrameContentsHead = jFrameContents.find('head');

        jFrameContentsHead.append(`<meta http-equiv="X-UA-Compatible" content="IE=edge">`);

        $.ajax({
          url: '/css/iframe-preview.css',
          success: (response) => {
            let style = document.createElement('style');
            style.type = 'text/css';
            style.media = 'screen';
            if (style.styleSheet) {
              style.styleSheet.cssText = response;
            } else {
              style.appendChild(document.createTextNode(response));
            }
            jFrameContentsHead.append(style);

            resolve();
          },
        });

        if (filePath.css) {
          jFrameContentsHead.append(`<link rel="stylesheet" href="/${filePath.css}">`);
        }
        if (filePath.js) {
          jFrameContentsHead.append(`<script type="text/javascript" src="/${filePath.js}">`);
        }
      });
    }

    /**
     * Подготовить загруженный документ к предпросмотру.
     *
     * @method _prepareContents
     * @param {object} jFrame jQuery-объект iframe предпросмотра.
     * @param {string} extension
     * @private
     * @static
     */
    static _prepareContents(jFrame, extension) {
      log.info('PREVIEW', 'Preparing contents');

      // iPad не умеет скроллить внутри iframe, так что обернём его в контейнер
      if (this._isIpad && extension.toUpperCase() === 'DPAD' && jFrame.parent().attr('id') !== 'preview-scroller') {
        const scrollerStyle = [
          '-webkit-overflow-scrolling: touch;',
          `height: ${$(window).height() - jFrame.offset().top}px;`,
          'overflow: auto;',
        ];
        jFrame.wrap(`<div id="preview-scroller" style="${scrollerStyle.join(' ')}"></div>`);
        jFrame.css({
          display: 'block',
          height: '100%',
        });
      }
    }
  }

  global.BaseDocumentPostprocessor = BaseDocumentPostprocessor;

})(window.Core.preview);